"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
// tslint:disable:max-classes-per-file
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        controls.multilineLookupFeatureName = "CLIMultiLineLookupFeature";
        /**
         * Framework class for Multiline Input controls
         */
        var MultilineInput = /** @class */ (function (_super) {
            __extends(MultilineInput, _super);
            function MultilineInput() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            MultilineInput.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.$inputElement = this.$cachedElement.find("textarea");
                this.DisableAutoPresentLookup = true;
                if ($dyn.value(this.DisplayHeight) === 0) {
                    if (this.isInGrid() === true) {
                        $dyn.setValue(this, "DisplayHeight", 2);
                    }
                    else {
                        $dyn.setValue(this, "DisplayHeight", 5);
                    }
                }
                this.ShowLookupButton = $dyn.computed(function () {
                    return $dyn.value(_this.LookupButton) && $dyn.util.isFlightEnabled($dyn.controls.multilineLookupFeatureName);
                });
            };
            MultilineInput.prototype.dispose = function () {
                var e_1, _a;
                if (this.ShowLookupButton && this.ShowLookupButton.valueChanged) {
                    this.ShowLookupButton.valueChanged.clearAllDependencies();
                }
                if (this.flyoutDisposables) {
                    try {
                        // This can be set if flyout is opened on multiline input programmatically
                        for (var _b = __values(this.flyoutDisposables), _c = _b.next(); !_c.done; _c = _b.next()) {
                            var disposable = _c.value;
                            disposable.dispose();
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    this.flyoutDisposables = null;
                }
                _super.prototype.dispose.call(this);
            };
            MultilineInput.prototype.attached = function () {
                _super.prototype.attached.call(this);
                this.$inputElement = this.$cachedElement.find("textarea");
                if (this._) {
                    this._.input = $("textarea", this.element)[0];
                }
            };
            return MultilineInput;
        }($dyn.controls.Input));
        controls.MultilineInput = MultilineInput;
        MultilineInput.prototype.DisplayHeight = 0;
        // tslint:disable:object-literal-sort-keys
        var multilineShortcuts = {
            Enter: {
                Keys: { keyCode: $dyn.ui.KeyCodes.enter },
                Handler: function (evt) {
                    if (evt) {
                        evt.stopPropagation();
                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Prevent form level Enter shortcut.");
                    }
                    return false;
                },
                RecordTelemetry: false,
                ShowToUser: false,
            },
        };
        MultilineInput.prototype.Shortcuts = $dyn.extendPrototype(controls.Input.prototype.Shortcuts, multilineShortcuts);
        $dyn.adapter({ id: "MultilineInputSummary", controlType: "Input", template: "SummaryField" });
        $dyn.adapter({ id: "MultilineInputLabel", controlType: "Input", template: "Label" });
        $dyn.adapter({ id: "MultilineInputCardCell", controlType: "Input", template: "CardCell" });
        var MultilineInputCell = /** @class */ (function (_super) {
            __extends(MultilineInputCell, _super);
            function MultilineInputCell(data, element, parent, role) {
                var _this = _super.call(this, data, element, parent, role) || this;
                // All cells are editable (because allow edit is not virtualized)
                _this.AllowEdit = $dyn.observable(true);
                return _this;
            }
            MultilineInputCell.prototype.updateValue = function () {
                return this._onChange();
            };
            MultilineInputCell.prototype.addMessage = function (messageId) {
                if (!this.messages) {
                    this.messages = [];
                }
                this.messages.push(messageId);
            };
            MultilineInputCell.prototype._onChange = function () {
                var isDirty = false;
                if (this._committedValue !== this.currentValue) {
                    isDirty = true;
                    this._committedValue = this.currentValue;
                    // Raise a retargeted "change" event
                    this.RaiseEvent($dyn.ui.ChangeEvent, {
                        bubbles: true,
                    });
                }
                return isDirty;
            };
            MultilineInputCell.prototype._setValue = function () {
                // Force the value to be dirty
                this._committedValue = undefined;
            };
            MultilineInputCell.prototype.GetState = function () {
                // todo: Check against value?
                return {
                    formattedValue: this.currentValue,
                    messages: this.messages
                };
            };
            MultilineInputCell.prototype.ApplyState = function (clientState) {
                var retVal = $.Deferred();
                var formattedValue = clientState && clientState.formattedValue;
                if (formattedValue !== undefined) {
                    this.currentValue = formattedValue;
                }
                retVal.resolve();
                return retVal;
            };
            MultilineInputCell.prototype.attached = function () {
                this._ = {};
                _super.prototype.attached.call(this);
                this._committedValue = this.currentValue;
                this.Value = $dyn.observable(this._committedValue);
            };
            Object.defineProperty(MultilineInputCell.prototype, "currentValue", {
                get: function () {
                    return this._.input.value;
                },
                set: function (value) {
                    this._.input.value = value;
                },
                enumerable: false,
                configurable: true
            });
            return MultilineInputCell;
        }(MultilineInput));
        controls.MultilineInputCell = MultilineInputCell;
        $dyn.ui.addPropertiesToPrototype(MultilineInputCell.prototype, {
            validating: { defaultValue: false, attribute: "data-dyn-validating" }
        });
        $dyn.cellAdapter({ id: "MultilineInput" });
        $dyn.cellAdapter({ id: "MultilineInput", controlType: "MultilineInputCell", type: $dyn.cellTypes.editor });
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=MultilineInput.js.map
